<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--down" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="#E35F5F"/></svg></template>